import { useState, useEffect } from "react";
import './targetPracticePage.css';

function TargetPractice() {
  // eslint-disable-next-line
  const [seconds, setSeconds] = useState(0);
  //this is whether the code is currently running a timer or not.
  const [timerActive, setTimerActive] = useState(false);
  //this is which game is being edited by the code.
  const [activeGameNumber, setActiveGameNumber] = useState(-1);
  //each game has a timer, name, ID, and number of targets/targets hit.
  const [games, setGames] = useState<any[]>([]);

  const changeActiveGame = (gameID: number) => {
    setActiveGameNumber(gameID);
    setTimerActive(false);
    setSeconds(0);
  }

  const generateID = () => {
    const used = games.map(g => g.gameID);
    for (let i = 0; i < 5; i++) {
      if (!used.includes(i)) return i;
    }
    return null;
  };

  // **target practice cards state**
  const addCard = () => {
    if (games.length < 5) {
      setGames(prev => [...prev, { name: "", gameID: generateID(), timer: 0, targets: 0, targetsHit: 0, hasBeenPlayed: false }]);
    }
  };

  const removeCard = (gameID: number) => {
    setGames(prev => prev.filter(game => game.gameID !== gameID));
    if (activeGameNumber === gameID) {
      setActiveGameNumber(-1);
      setTimerActive(false);
      setSeconds(0);
    }
  };

  useEffect(() => {
    const handleKeyDown = (event: KeyboardEvent) => {
      if (event.key === "p") {
        if (activeGameNumber !== -1) {
          if (games.find(g => g.gameID === activeGameNumber)?.hasBeenPlayed === false) {
            setTimerActive(true);
            setGames(prev => {
              return prev.map(g => {
                if (g.gameID === activeGameNumber) {
                  return { ...g, hasBeenPlayed: true };
                } else {
                  return g;
                }
              });
            });
          } else if (games.find(g => g.gameID === activeGameNumber)?.hasBeenPlayed === true) {
            setGames(prev => {
              return prev.map(g => {
                if (g.targetsHit >= g.targets) {
                  setTimerActive(false);
                  setActiveGameNumber(-1);
                  return g;
                } else {
                  return g;
                }
              });
            });
          }

        }
      } else if (event.key === "h") {
        if (activeGameNumber !== -1) {
          TargetHit();
        }
        /*} else if (event.key === "s") {
          if (activeGameNumber !== -1) {
            setGames(prev => {
              return prev.map(g => {
                if (g.targetsHit === g.targets) {
                  setTimerActive(false);
                  setActiveGameNumber(-1);
                  return g;
                } else {
                  return g;
                }
              });
            });
          }*/
      } else if (event.key === "l") {
        console.log(games);
      }
    };

    window.addEventListener("keydown", handleKeyDown);
    return () => {
      window.removeEventListener("keydown", handleKeyDown);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [games, activeGameNumber]);

  const TargetHit = () => {
    setGames((prev) => {
      const game = prev.find(g => g.gameID === activeGameNumber);
      if (!game) return prev;
      return prev.map(g => {
        if (g.gameID === activeGameNumber && g.targetsHit < g.targets && timerActive) {
          return { ...g, targetsHit: g.targetsHit + 1 };
        }
        return g;
      });
    });
  }

  const renderTargetIcons = (targets: number, targetsHit: number) => {
    return Array.from({ length: targets }, (_, index) => (
      <span
        key={index}
        className={`target-icon ${index < targetsHit ? "hit" : ""}`}
      >
        🎯
      </span>
    ));
  };


  useEffect(() => {
    let timer: any = null;
    if (timerActive && activeGameNumber !== -1) {
      timer = setInterval(() => {
        setSeconds((prevSeconds) => {
          if (!timerActive) {
            return 0;
          } else {
            setGames((prev) => {
              return prev.map((game) => {
                if (game.gameID === activeGameNumber) {
                  return {
                    ...game,
                    timer: prevSeconds,
                  };
                }
                return game;
              });
            });
            return prevSeconds + 1;
          }
        });
      }, 1000);
    }
    return () => clearInterval(timer);
  }, [timerActive, activeGameNumber]);


  return (
    <div className="scoreboard-container">
      {/* card add button uses scoreboard plus styling */}
      <div className="target-practice-controls">
        <div className="cards-container">
          {games.map((game: any) => (
            <div key={game.gameID} className="game-card" >
              <p className="game-card-text">{" "} </p>
              <input disabled={game.gameID !== activeGameNumber} type="text" id="gamename" name="gamename" maxLength={20} placeholder={"game " + (game.gameID + 1)} className="game-card-text" />
              <button
                type="button"
                className={`active-game-button ${game.gameID === activeGameNumber ? "active" : "inactive"}`}
                onClick={() => changeActiveGame(game.gameID)}
              >
                {game.gameID === activeGameNumber ? "Active" : "Select"}
              </button>
              <p className="game-card-text">{"Time: " + game.timer} </p>
              {/*<p className="game-card-text">{"Targets: " + game.targets} </p>*/}

              {/*<p className="game-card-text">{"Targets Hit: " + game.targetsHit} </p>*/}
              {!game.hasBeenPlayed && (
                <>
                  <button disabled={game.gameID !== activeGameNumber} onClick={() => setGames(prev => {
                    return prev.map((g) => {
                      if (g.gameID === game.gameID && g.targets > 0) {
                        return { ...g, targets: g.targets - 1 };
                      } else {
                        return g;
                      }
                    });
                  })}>-</button>
                  <button disabled={game.gameID !== activeGameNumber} onClick={() => setGames(prev => {
                    return prev.map((g) => {
                      if (g.gameID === game.gameID) {
                        if (g.targets < 4) {
                          return { ...g, targets: g.targets + 1 };
                        } else {
                          return g;
                        }
                      } else {
                        return g;
                      }
                    });
                  })}>+</button>
                  <div className="target-icons">
                  </div>
                </>
              )}
              {renderTargetIcons(game.targets, game.targetsHit)}
              <button disabled={game.gameID !== activeGameNumber} type="button" className={`delete-card-button ${game.gameID === activeGameNumber ? "active" : "inactive"}`} onClick={() => removeCard(game.gameID)}>
                Delete
              </button>
            </div>
          ))}
        </div>
        {games.length < 5 && (<><button className="y-plus-button" onClick={addCard}></button></>)}
      </div>
    </div>
  );
}

export default TargetPractice;